var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocketImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 135,
    viewBox: "0 0 109 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.337 4.72581C53.3782 4.2373 54.093 4.2373 54.1342 4.72581L60.5095 80.3151C60.5986 81.3711 60.8735 82.4031 61.3215 83.3635L83.2213 130.309C83.4288 130.754 82.8074 131.109 82.5293 130.705L57.031 93.6424C55.4415 91.332 52.0297 91.332 50.4402 93.6424L24.9419 130.705C24.6637 131.109 24.0424 130.754 24.2499 130.309L46.1497 83.3636C46.5977 82.4031 46.8726 81.3711 46.9617 80.3151L53.337 4.72581Z",
    fill: "url(#paint0_linear_5_30)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0523 80.6304L48.2869 63.6763C48.3027 63.4601 48.6031 63.42 48.6751 63.6245L60.9168 98.4021C60.9926 98.6175 60.7063 98.7713 60.5686 98.5891L47.0923 80.7656C47.063 80.7269 47.0488 80.6788 47.0523 80.6304Z",
    fill: "#282A32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.85156,
    y: 115.113,
    width: 3.79655,
    height: 1.30491,
    transform: "rotate(135 9.85156 115.113)",
    fill: "url(#paint1_linear_5_30)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.79655,
    height: 1.30491,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 99.0039 115.113)",
    fill: "url(#paint2_linear_5_30)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.20467,
    height: 1.30491,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 2.63281 122.331)",
    fill: "url(#paint3_linear_5_30)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 0.547229,
    height: 1.30491,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 0.951172 124.013)",
    fill: "url(#paint4_linear_5_30)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 106.223,
    y: 122.331,
    width: 2.20467,
    height: 1.30491,
    transform: "rotate(-135 106.223 122.331)",
    fill: "url(#paint5_linear_5_30)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 107.574,
    y: 123.68,
    width: 0.322549,
    height: 1.30491,
    transform: "rotate(-135 107.574 123.68)",
    fill: "url(#paint6_linear_5_30)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1398 111.741L73.5642 89.1659C70.3634 85.9651 68.2825 81.8157 67.6316 77.3362L58.8926 17.1909",
    stroke: "url(#paint7_linear_5_30)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9052 111.741L34.4808 89.1659C37.6815 85.9651 39.7624 81.8157 40.4133 77.3362L49.1523 17.1909",
    stroke: "url(#paint8_linear_5_30)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.5446 56.7304L41.1289 30.9438",
    stroke: "url(#paint9_linear_5_30)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M74.9382 76.7864L71.5 56.1572",
    stroke: "url(#paint10_linear_5_30)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M68.0601 41.8316L66.9141 33.8091",
    stroke: "url(#paint11_linear_5_30)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M46.2863 8.02243L46.8594 4.58423",
    stroke: "url(#paint12_linear_5_30)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_30",
    x1: 101.635,
    y1: 186.789,
    x2: 3.61233,
    y2: 44.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_30",
    x1: 11.7498,
    y1: 115.113,
    x2: 11.7498,
    y2: 116.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_30",
    x1: 1.89827,
    y1: 0,
    x2: 1.89827,
    y2: 1.30491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_30",
    x1: 1.10234,
    y1: 0,
    x2: 1.10234,
    y2: 1.30491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_30",
    x1: 0.273615,
    y1: 0,
    x2: 0.273615,
    y2: 1.30491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_30",
    x1: 107.325,
    y1: 122.331,
    x2: 107.325,
    y2: 123.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_30",
    x1: 107.735,
    y1: 123.68,
    x2: 107.735,
    y2: 124.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_30",
    x1: 83.2465,
    y1: 17.1909,
    x2: 83.2465,
    y2: 111.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_30",
    x1: 33.6804,
    y1: 19.4831,
    x2: 24.7984,
    y2: 111.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5_30",
    x1: 27.9491,
    y1: 19.4832,
    x2: 19.0671,
    y2: 111.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5_30",
    x1: 83.5337,
    y1: 39.5393,
    x2: 92.4157,
    y2: 131.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5_30",
    x1: 78.9478,
    y1: 15.472,
    x2: 87.8298,
    y2: 107.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5_30",
    x1: 36.5448,
    y1: -19.4832,
    x2: 27.6628,
    y2: 72.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketImg);
export default __webpack_public_path__ + "static/media/rocket-img.4b075e68f4a7e878a19c66038cc0b744.svg";
export { ForwardRef as ReactComponent };